import { render, staticRenderFns } from "./MemberTab.vue?vue&type=template&id=c5d9fa2e&scoped=true&"
import script from "./MemberTab.vue?vue&type=script&lang=js&"
export * from "./MemberTab.vue?vue&type=script&lang=js&"
import style0 from "./MemberTab.vue?vue&type=style&index=0&id=c5d9fa2e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d9fa2e",
  null
  
)

export default component.exports